// ------------------------------------
// Constants
// ------------------------------------
export const INIT = 'INIT';
export const INIT_DONE = 'INIT_DONE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// ------------------------------------
// Actions
// ------------------------------------
export const init = () => ({ type: INIT });
export const initDone = payload => ({ type: INIT_DONE, payload });
export const loginSuccess = payload => ({ type: LOGIN_SUCCESS, payload });
export const logout = () => ({ type: LOGOUT });
export const logoutSuccess = () => ({ type: LOGOUT_SUCCESS });

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  initializing: false,
  loggingOut: false,
  isLoggedIn: false,
  roles: []
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case INIT:
      return { ...state, initializing: true };
    case INIT_DONE:
      return {
        ...state,
        initializing: false,
        isLoggedIn: !!payload.isLoggedIn,
        roles: payload.roles
      };
    case LOGIN_SUCCESS:
      console.log(payload);
      return {
        ...state,
        isLoggedIn: true,
        roles: payload.roles
      };
    case LOGOUT:
      return { ...state, loggingOut: true };
    case LOGOUT_SUCCESS:
      return { ...state, loggingOut: false, isLoggedIn: false, roles: [] };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/auth.js